import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { intlShape } from 'react-intl';

import config from '../../../config';
import { twitterPageURL } from '../../../util/urlHelpers';
import {
  ExternalLink,
  IconSocialMediaFacebook,
  IconSocialMediaInstagram,
  IconSocialMediaTwitter,
} from '../../../components';

import css from './SocialSection.module.css';

const SocialSection = (props) => {
  const { className, headingClassName, linkClassName, headingText, intl } = props;
  const { siteFacebookPage, siteInstagramPage, siteTwitterHandle } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const goToFb = intl.formatMessage({ id: 'Footer.goToFacebook' });
  const goToInsta = intl.formatMessage({ id: 'Footer.goToInstagram' });
  const goToTwitter = intl.formatMessage({ id: 'Footer.goToTwitter' });
  const facebookText = intl.formatMessage({ id: 'Footer.facebook' });
  const instagramText = intl.formatMessage({ id: 'Footer.instagram' });
  const twitterText = intl.formatMessage({ id: 'Footer.twitter' });
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      <h2 className={headingClassName}>{headingText}</h2>
      {siteFacebookPage ? (
        <ExternalLink href={siteFacebookPage} className={linkClassName} title={goToFb}>
          <IconSocialMediaFacebook className={css.icon} />
          {facebookText}
        </ExternalLink>
      ) : null}
      {siteInstagramPage ? (
        <ExternalLink href={siteInstagramPage} className={linkClassName} title={goToInsta}>
          <IconSocialMediaInstagram className={css.icon} />
          {instagramText}
        </ExternalLink>
      ) : null}
      {siteTwitterPage ? (
        <ExternalLink href={siteTwitterPage} className={linkClassName} title={goToTwitter}>
          <IconSocialMediaTwitter className={css.icon} />
          {twitterText}
        </ExternalLink>
      ) : null}
    </div>
  );
};

SocialSection.defaultProps = {
  className: null,
};

SocialSection.propTypes = {
  className: string,
  headingClassName: string.isRequired,
  linkClassName: string.isRequired,
  headingText: string.isRequired,
  intl: intlShape.isRequired,
};

export default SocialSection;
